import LinkIcon from '@mui/icons-material/LinkOutlined';
import CopyToClipboard from 'react-copy-to-clipboard';
import CopyIcon from '../../../../../assets/icons/copy.svg?url';
import OpenPaymentLinkIcon from '../../../../../assets/icons/open-payment-link.svg?url';
import l from '../../../../../lang';
import Input from '../../../../common/input';
import ButtonCustom from '../../../../common/__deprecated__/button-custom';
import ShareButtons from './share-buttons';
import './styles.scss';
import { useEffect, useState } from 'react';
import { useDashboard } from '../../../../../store/dashboard';
import { segmentShareOpenLink } from '../../../../../utils/analytics';

const CreatedOpenPaymentLink = () => {
  const [url, setUrl] = useState('');
  const { merchantMe, userMe } = useDashboard();

  useEffect(() => {
    const checkoutUrl = import.meta.env.REACT_APP_CHECKOUT_DOMAIN_DLGO;

    if (merchantMe) {
      const decryptedToken = `open_link:mid:${merchantMe.id}`;
      const paymentLink = `${checkoutUrl}/open-checkout/${btoa(decryptedToken)}`;
      setUrl(paymentLink);
    }
  }, [merchantMe]);

  const handleCopy = () => {
    if (!merchantMe || !userMe) return;
    segmentShareOpenLink({ channel: 'copy', valid: 1, merchantId: merchantMe.id, userId: userMe.id });
  };

  return (
    <div className="created_open_payment_link">
      <img src={OpenPaymentLinkIcon} alt="Open Payment Link" />
      <h1>{l('openPaymentLink.title')}</h1>
      <div className="created_open_payment_link__subheadline">{l('openPaymentLink.subheadline')}</div>
      <div className="created_open_payment_link__subheadline">{l('paymentLink.shareLink.subheadline1')}</div>
      <div className="share_aff_link__link">
        <div className="input">
          <Input name="copyLink" value={url} prefix={<LinkIcon color="primary" />} readOnly disabled />
        </div>
        <CopyToClipboard text={url} onCopy={() => handleCopy()}>
          <ButtonCustom
            name="btn-confirm"
            text={l('paymentLink.shareLink.copyLink')}
            color="primary"
            variant="contained"
            startIcon={<img className="share_aff_link__img_copy" src={CopyIcon} />}
          />
        </CopyToClipboard>
      </div>
      <div className="created_open_payment_link__subheadline">{l('paymentLink.shareLink.subheadline2')}</div>
      <ShareButtons link={url} validReferrer={true} />
    </div>
  );
};

export default CreatedOpenPaymentLink;
